query CompanyCardCompanies(
  $filter: CompanyCardCompanyFilter
  $orderBy: [CompanyCardCompaniesOrderBy!]
) {
  companyCardCompanies(filter: $filter, orderBy: $orderBy) {
    nodes {
      id
      _rowTimestamp
      _cardCompanyName
      cardCompanyId
      _isPayCard
      apiKey
      _isManualProcess
      _isUpdatable
      _isDeletable
      cardAccounts {
        nodes {
          description
          businessUnitId
        }
      }
    }
  }
}
